
<template>
  <swiper
    class="clickable"
    :modules="modules"
    :slides-per-view="'auto'"
    :speed="4000"
    :slides-per-group="1"
    :loop-add-blank-slides= "true" 
    :space-between="12"
    :loop="true"
    :breakpoints = breakpoints
    :autoplay="{ delay: 0, disableOnInteraction: false,}"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index" :data-numb="index + 1">
      <figure><img :src="item.pic" :alt="item.ttl"></figure>
      <h3 v-html="item.ttl"></h3>
      <p v-html="item.text"></p>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  max-width: 24rem;
  height: auto;
  background: module.$white;
  border: module.$border 1px solid;
  padding: 1.6rem;
  border-radius: 1rem;
  position: relative;
  &:before{
    content: attr(data-numb);
    width: 3.2rem;
    height: 3.2rem;
    position: absolute;
    top: 0;
    left: 0;
    background: module.$orange;
    color: module.$white;
    font-size: 1.44rem;
    @include module.flex();
    align-items: center;
    justify-content: center;
    border-radius: 1rem 0 1rem 0;
  }
  figure{
    padding: 1.6rem 20%;
    border-bottom: module.$border 1px solid;
    img{
      width: 100%;
    }
  }
  h3{
    margin: 1.6rem 0 .8rem;
    font-size: 1.2rem;
    &:before{
      content: '●';
      color: module.$orange;
      display: inline-block;
      margin: 0 .4rem 0 0;
      transform: translateY(-4%);
    }
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
      const breakpoints = {
      1024: {
        spaceBetween: 20,
      },
      640: {
        spaceBetween: 20,
      },
    }

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      breakpoints,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
    }
  },
}
</script>
